var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"warp"},[_c('ul',{staticClass:"ul"},_vm._l((_vm.expression),function(item){return _c('li',{key:item.id},[_c('div',{staticClass:"li-box"},[_c('div',{staticClass:"li-box-title"},[_vm._v(_vm._s(item.displayName))]),_c('div',{staticClass:"li-box-value"},[_vm._v(_vm._s(item.value))])])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }